import api from '../api';
import serviceType from './service-type';

export default {
  findCore() {
    const filters = { type: serviceType.CORE };
    return api
      .get('services', { params: filters })
      .then(response => response.data);
  },
};
